const AttendanceResultStatuses = [
  { id: 'NOT_AUTHORIZED',   name: 'resources.attendanceResultSummaries.statuses.NOT_AUTHORIZED' },
  { id: 'AUTHORIZED',       name: 'resources.attendanceResultSummaries.statuses.AUTHORIZED' },
]

export default AttendanceResultStatuses